import { useUserEnvironment } from 'contexts/UserEnvironmentContext';
import { getSearchLocation } from 'modules/search/zustand-stores/searchStore';

export function useSearchReady() {
  const { isEnvironmentLoaded } = useUserEnvironment();

  const initialSearchLocationSet = typeof getSearchLocation() !== 'undefined';

  const mainSearchReady = isEnvironmentLoaded && initialSearchLocationSet;

  return { mainSearchReady };
}
